const jsonSetPathValue = (obj, _path, value) => {
    
    //    const path = Array.isArray(_path) ? _path : _path.split(".")
    const path = _path.constructor.name === "Array" ? _path: _path.split(".")

    const pathHead = path[0]
    const pathTail = path.slice(1) // remainder
    //console.log("pathHead = ", pathHead)
    //console.log("pathTail = ", pathTail)
    if(pathTail.length === 0) {
	obj = {
	    ...obj,
	    [pathHead]: value
	}
	return obj
    } else {
	// console.log("obj =", obj)
	if(!obj) {
	    obj = {}
	}
	if(!obj[pathHead]) {
	    // if does not exist, create it so that we can fill it below
	    obj[pathHead] = "" // null or undefined don't work
	}
	return {
	    ...obj,
	    [pathHead]: jsonSetPathValue(obj[pathHead], pathTail, value)
	}
    }
}

const jsonHasPath = (obj, _path) => {
    const path = _path.split(".").filter(p => p !== '')
    let isFound = false
    if(!obj || (obj.constructor !== ({}).constructor)) return isFound
    for(let key of Object.keys(obj)) {
	if(key === path[0]) {
	    const remainPath = path.slice(1, path.length + 1).join(".")
	    if(remainPath)  {
		isFound = jsonHasPath(obj[key], remainPath)
	    } else {
		isFound = true
	    }
	}
    }
    return isFound
}


const jsonPretty = json => (JSON.stringify(json, null, " "))
const jsonString = json => (JSON.stringify(json))


const jsonDeleteValues = (obj, values) => {
    let retObj = {}
    for(let [key, value] of Object.entries(obj)) {
	////console.log("key =", key)
	////console.log("value =", value)
	if(values.includes(value)) {
	    // //console.log("skipping key=", key)
	} else {
	    if(obj[key] && obj[key].constructor && obj[key].constructor.name === "Object") {
		const sub = jsonDeleteValues(obj[key], values)
		//console.log("sub =", sub)
		if(sub) {
		    retObj = {
			...retObj,
			[key]: sub
		    }
		}

	    } else if(obj[key]){
		retObj = {
		    ...retObj,
		    [key]: obj[key]
		}
	    }
	}
    }
    return JSON.stringify(retObj) !== JSON.stringify({}) ? retObj : undefined
}

const jsonDeleteKeys = (obj, keys) => {
    let retObj = {}
    for(let key of Object.keys(obj)) {
	// //console.log("key =", key)
	if(keys.includes(key)) {
	    // //console.log("skipping key=", key)
	} else {
	    if(obj[key] && obj[key].constructor && obj[key].constructor.name === "Object") {
		// //console.log("it is an object key=", key)
		retObj = {
		    ...retObj,
		    [key]: jsonDeleteKeys(obj[key], keys)
		}
	    } else if(obj[key]){
		retObj = {
		    ...retObj,
		    [key]: obj[key]
		}
	    }
	}
    }
    return retObj
}

const jsonPointerHas = (obj, _path) => {
    const path = _path.split("/").filter(p => p !== '')
    ////console.log("jsonExists(): path =", path)
    let isFound = false
    if(!obj || (obj.constructor !== ({}).constructor)) return isFound
    for(let key of Object.keys(obj)) {
	////console.log("jsonExists(): key =", key)
	if(key === path[0]) {
	    ////console.log("jsonExists(): found =", key)
	    const remainPath = path.slice(1, path.length + 1).join("/")
	    ////console.log("jsonExists(): remain path =", remainPath)
	    ////console.log("jsonExists(): obj[key] =", obj[key])
	    if(remainPath)  {
		isFound = jsonPointerHas(obj[key], remainPath)
	    } else {
		isFound = true
	    }
	}
    }
    return isFound
}

const hasValidUser = (urlObj) => {
    
    if(!urlObj) return false
    if(!urlObj.user) return false
    if(urlObj.user.uuid) return true

    return false
}

const hasValidArgs = (urlObj) => {
    return false
}

const makeRegex = (terms) => {

    let regex
    for(let regexString, i = 0, length = terms.length; i < length; i ++) {
	i === 0 ?
	    regexString = `(${terms[i]})`
	    : regexString += `.*(${terms[i]})`
	regex = new RegExp(regexString,"i")
    }

    //console.log("makeRegex(): regex =", regex)
    return regex
}


const getFilteredIssues = (_issues, query) => {
    const issues = JSON.parse(JSON.stringify(_issues))
    
    if(!query) {
	return issues
    }

    const terms = query.trim().split(" ")
    ////console.log("getFilteredIssues(): terms =", terms)
    ////console.log("getFilteredIssues(): issues =", issues)

    const regex = makeRegex(terms)
    //const regex = /GQL/i
    
    const matchedIssues = []
    issues.forEach(issue => {
	const matchInfos = matchPropValues(issue, regex, ["slug","txt", "tags", "statements"])
	////console.log("getFilteredIssues(): matchInfo =", matchInfo)
	if(matchInfos) {
	    matchedIssues.push({
		...issue,
		matchInfos
	    })
	}
    })

    ////console.log("getFilteredIssues(): matchedIssues =", matchedIssues)
    return matchedIssues
}

const getFilteredItems = (_items, query) => {
   //const issues = JSON.parse(JSON.stringify(_issues))

    const items = JSON.parse(JSON.stringify(_items))

    if(!query) {
	return items
    }

    const terms = query.trim().split(" ")

    const regex = makeRegex(terms)

    const matchedItems = []
    items.forEach(item => {
	const matchInfos = matchPropValues(item, regex, ["slug","txt", "tags", "statements", "issues", "postTemplates", "geo", "address", "zip", "code"]) // not all of them are used
	// $.geo.address.zip.code
	// console.log("getFilteredIssues(): matchInfos =", matchInfos)
	if(matchInfos) {
	    matchedItems.push({
		...item,
		matchInfos
	    })
	}
    })

    return matchedItems
}


const makeUrl = (urlObj, newAttr) => {
    //console.log("makeUrl(): urlObj =", urlObj)
    
    let retUrl = `${urlObj.location.pathname}`

    if(urlObj.searchString) {
	retUrl += `?s=${urlObj.searchString}`
    } else {
	retUrl += `?s=`
    }

    if(urlObj.slug) {
	retUrl += `&slug=${urlObj.slug}`
    }

    if(urlObj.caller) {
	retUrl += `&caller=${urlObj.caller}`
    }

    if(urlObj.uuid) {
	retUrl += `&uuid=${urlObj.uuid}`
    }


    if(newAttr) {
	retUrl += `&${newAttr.k}=${newAttr.v}`
    }

    /* we don't need this 'cause it's done with newAttr?
    if(urlObj.tag) {
	retUrl += `&tag=${urlObj.tag}`
    }
    */
    
    if(urlObj.filters) {
	retUrl += `&filters=${JSON.stringify(urlObj.filters)}`
    }

    return retUrl
}


const parseUrl = (location, match = undefined) => {
    const entity = location.pathname.substring(1)
    const retObj = {
	location,
	[entity]: {}
    }

    if(match) retObj.match = match

    const decodedUrl = decodeURIComponent(location.search)
    const params = new URLSearchParams(decodedUrl)

    //console.log("<Util>: parseUrl(): decodedUrl =", decodedUrl)
    //console.log("<Util>: parseUrl(): params =", params)

    const options = [
	{name: "s", type: "string"},
	{name: "tag", type: "string"},
	{name: "caller", type: "string"},
        {name: "slug", type: "string"},
        {name: "uuid", type: "string"},
        {name: "email", type: "string"},
        {name: "action", type: "string"},
	{name: "user", type: "plain"},
        {name: "filters", type: "json"}
    ]

    options.forEach(option => {
        if(params.get(option.name)) {
            let optionValue
	    switch (option.type) {
	    case "string":
                optionValue = params.get(option.name).replace(/"/g, "")
		break
	    case "json":
                optionValue = JSON.parse(params.get(option.name))
		break
	    default:
	    }
	    
	    /*
            if(option.type === "string") {
                optionValue = params.get(option.name).replace(/"/g, "")
                //console.log(`<PostTemplate>: parseUrl(): got plain ${option.name} =`, optionValue)
            } else if(option.type === "json") {
                optionValue = JSON.parse(params.get(option.name))
                //console.log(`<PostTemplate>: parseUrl(): got json ${option.name} =`, optionValue)
            }
	    */
            //console.log(`<Util>: parseUrl(): got ${option.name} =`, optionValue)

	    retObj[entity] = {
                ...retObj[entity],
		location,
                [option.name]: optionValue
            }

	    //console.log(`<Util>: parseUrl(): got retObj[${entity}]} =`, retObj[entity])

        }
    })

//    retObj[entity].location = location
    
//    console.log("<Util>: parseUrl(): returning retObj =", retObj)
    return retObj
}


const parseUrl_old = (location, match = undefined, params = undefined) => {
    let entity = location.pathname.substring(1)
    const retObj = {
	location,
	[entity]: {}
    }

    if(match) retObj.match = match
    if(params) retObj.params = params

    // look into the drive situation
    if(match && match.params) {
	if(match.params.driveSlug) {
	    retObj.drive = {
		slug: match.params.driveSlug
	    }
	}
    }
    

    const decodedUrl = decodeURIComponent(location.search)
    const searchParams = new URLSearchParams(decodedUrl)

    //console.log("<Util>: parseUrl(): decodedUrl =", decodedUrl)
    //console.log("<Util>: parseUrl(): searchParams =", searchParams)

    const options = [
	{name: "s", type: "string"},
	{name: "tag", type: "string"},
	{name: "caller", type: "string"},
        {name: "slug", type: "string"},
        {name: "uuid", type: "string"},
        {name: "action", type: "string"},
	{name: "user", type: "plain"},
        {name: "filters", type: "json"}
    ]

    options.forEach(option => {
        if(searchParams.get(option.name)) {
            let optionValue
	    switch (option.type) {
	    case "string":
                optionValue = searchParams.get(option.name).replace(/"/g, "")
		break
	    case "json":
                optionValue = JSON.parse(searchParams.get(option.name))
		break
	    default:
	    }
	    
	    /*
            if(option.type === "string") {
                optionValue = params.get(option.name).replace(/"/g, "")
                ////console.log(`<PostTemplate>: parseUrl(): got plain ${option.name} =`, optionValue)
            } else if(option.type === "json") {
                optionValue = JSON.parse(params.get(option.name))
                ////console.log(`<PostTemplate>: parseUrl(): got json ${option.name} =`, optionValue)
            }
	    */
            //console.log(`<Util>: parseUrl(): got ${option.name} =`, optionValue)

	    retObj[entity] = {
                ...retObj[entity],
		location,
                [option.name]: optionValue
            }

	    //console.log(`<Util>: parseUrl(): got retObj[${entity}]} =`, retObj[entity])

        }
    })

//    retObj[entity].location = location
    
    //console.log("<Util>: parseUrl(): returning retObj =", retObj)
    return retObj
}


/*
const getAllPropValues = (obj, keys, path) => {
    ////console.log("getAllPropValues(): obj =", obj)
    ////console.log("getAllPropValues(): keys =", keys)
    
    const retArray = []
    if(!path) { path = "$" }
    for([key,value] of Object.entries(obj)) {
//	////console.log("getAllPropValues(): key =", key)
//	////console.log("getAllPropValues(): key is number =", (key.match(/^\d+$/) !== null)) 
//	////console.log("getAllPropValues(): keys.includes(key) =", keys.includes(key))
//	////console.log("getAllPropValues(): value =", value)
//	////console.log("getAllPropValues(): typeof(value) =", typeof(value))
	if(!keys // if no keys defined, add this key by default
	   || key.match(/^\d+$/) // if the key is number, we are in the array already tag.0, add
	   || (keys.includes(key)) // key is defined and this is a key we want
	  ) {
	    if(typeof(value) === "object") {
		// go in if it's a branch
//		////console.log("getAllPropValues(): dive into")
		const values = getAllPropValues(value, keys, `${path}.${key}`)
		retArray.push(...values)
	    } else {
		retArray.push({key: `${path}.${key}`,value}) // add if it's a life
	    }
	}
    }
    return retArray
}
*/

const getPropValues = (obj, keys, path) => {
    ////console.log("getPropValues(): obj =", obj)
    ////console.log("getPropValues(): keys =", keys)

    const retArray = []
    if(!path) { path = "$" }
    ////console.log("getPropValues(): Object.entries(obj) =", Object.entries(obj))
    for(const [key, value] of Object.entries(obj)) {
	////console.log("getPropValues(): key =", key)
	////console.log("getPropValues(): value =", value)
	if(true // maybe something here later
	   && (!keys // if no keys defined, add this key by default
	       || key.match(/^\d+$/) // if the key is number, we are in the array already tag.0, add
	       || (keys.includes(key)) // key is defined and this is a key we want
	      )
	  ) {
	    if(typeof(value) === "object") {
		if(value !== null
		   && value.length !== 0) {
		    // go in if it's a branch
		    // //console.log("getPropValues(): dive into value =", value)
		    const values = getPropValues(value, keys, `${path}.${key}`)
		    if(values !== null) {
			retArray.push(...values)
		    }
		}
	    } else {
		retArray.push({key: `${path}.${key}`,value}) // add if it's a lief
	    }
	}
    }
    return retArray.length > 0 ? retArray : null
}

const matchPropValues = (obj, regex, keys) => {
    ////console.log("matchPropValues(): obj =", obj)

    const retArray = []
    
    if(!obj) return retArray

    getPropValues(obj, keys).forEach(propValue => {
	////console.log("matchPropValues(): propValue =", propValue)
	const matchResult = propValue.value.match(regex)
	////console.log("matchPropValues(): matchResult =", matchResult)
	if(matchResult) {
	    const {index, input, groups, ...matches} = matchResult
	    ////console.log("matchPropValues(): index =", index)
	    ////console.log("matchPropValues(): matches =", matches)
	    ////console.log("matchPropValues(): matches[0] =", matches[0])
	    const grps = []
	    // here we can have [key, value]
	    for(const [key] of Object.entries(matches)) {
		const begin = input.indexOf(matches[key])
		const end = begin + matches[key].length
		grps.push({grp: matches[key], begin, end})
	    }
	    retArray.push({...propValue, grps})
	}
    })
    
    return retArray.length > 0 ? retArray : null
}


/*
examples:

        const groupedDrives = groupBy(filteredDrives, v => {
            return v.slug
        })

	const groupedFeatures = groupBy(geoJson.features, f => {
	    //return `${f.properties.ZipCode}, ${f.properties.local_district_id}`
	    return `${f.properties.ZipCode}, ${f.properties.local_district_id}, ${f.properties.local_ocd_id}`
//	    return f.properties.ZipCode
	})


*/
const groupBy = (array, f) => {
    return array.reduce((acc, obj) => {
	const key = f(obj)
	if(!acc[key]) {
	    acc[key] = []
	}
	acc[key].push(obj)
	return acc
    }, {})
}

// this sorts elements "inside" the group key
const groupSort = (groups, f) => {
    for(const value of Object.values(groups)) {
	value.sort(f)
    }
    return groups
}

/*
examples:
	const sortedGroupedFeatures = groupSortByKey(groupedFeatures, (a,b) => {
	    return a < b ? 1 : -1 // latest first
	})
*/

// this sorts by the group key itself
const groupSortByKey = (groups, f) => {
    const keys = Object.keys(groups)
    //console.log("groupSortByKey(): keys = ", keys)
    keys.sort(f)
    //console.log("groupSortByKey = ", keys)
    const sortedGroups = {}
    keys.forEach(key => {
	sortedGroups[key] = groups[key]
    })

    return sortedGroups
}


const groupFlat = (groups) => {
    const retArray = []
    for(const  value of Object.values(groups)) {
	for(let i in value) {
	    retArray.push(value[i])
	}
    }
    return retArray
}

const getTagString = (issueOrStatement) => {
    //console.log("<Issue>: getTagString: issueOrStatement.tagString =", issueOrStatement.tagString)
    //console.log("<Issue>: getTagString: issueOrStatement.tags =", issueOrStatement.tags)
    if(!issueOrStatement.tagString) {
        if(!issueOrStatement.tags) {
            return ""
        } else {
            issueOrStatement.tagString  = "" + issueOrStatement.tags
            return issueOrStatement.tagString
        }
    } else {
        return issueOrStatement.tagString
    }
}

const makeTagArray = (tagString) => {
    
    if(tagString) {
        const tags = []
        tagString.split(",").forEach(tag1 => {
            tag1.split(" ").forEach(tag2 => {
	        //console.log("tag2 =", tag2)
	        if(tag2) {
	            tags.push(tag2)
	        }
            })
        })
        return tags
    } else {
        return []
    }
}

const deepCopy= (obj) => (obj ? JSON.parse(JSON.stringify(obj)) : undefined)

const makeCloneUser = (user) => {
    //console.log("<Utils>: makeCloneUser(): user =", user)
    
    const cloneUser = deepCopy(user)
    delete cloneUser.contacts
    delete cloneUser.statements

    return cloneUser
}

// checks equality of JSON as well  
const includes = (array, obj) => {
    if(array.includes(obj)) {
	return true
    } else {
	for(let el of array) {
	    if(JSON.stringify(el) === JSON.stringify(obj)) {
		return true // this will return all the way from include
	    }
	}
    }
    return false
}

const distinct = (array, f) => {
    return array.reduce((acc, obj) => {
	const value = f(obj)
	//if(!acc.includes(value)) {
	if(!includes(acc, value)) {
	    acc.push(value)
	}
	return acc
    },[])
}

const round = (num, pos) => {
    const multiplier = 10**pos
    return Math.round(num * multiplier) / multiplier
}

const firstCross = (obj1, obj2) => {
    let firstCross
    for(let o1 of obj1) {
	//console.log("o1 =", o1)
	if(firstCross) break
	for(let o2 of obj2) {
	    if(JSON.stringify(o1) === JSON.stringify(o2)) {
		firstCross = o1
		break
	    }
	}
    }
    return firstCross
}

const getDistrictAttributes = (districtDescription) => {
    const defs = {
	"Arizona, USA": {
	    name: "Arizona"
	},
	"Atherton, CA": {
	    name: "Atherton"
	},
	"Atherton, CA 18th": {
	    name: "Atherton"
	},
	"California, USA": {
	    name: "California"
	},
	"Florence, AZ 4th": {
	    name: " Florence"
	},
	"Florence": {
	    name: " Florence"
	},
	"Hillsborough, CA 14th": {
	    name: " Hillsborough"
	},
	"Hillsborough, CA": {
	    name: " Hillsborough"
	}
    }
}


const getPositionAttributes = (positionName) => {
    const defs = {
	// FEDERAL
	"president": {
	    level: "federal",
	    description: "President of the US"
	},
	"congressMember": {
	    level: "federal",
	    description: "US Congress Member"
	},
	"vicePresident": {
	    level: "federal",
	    description: "Vice President of the US"
	},
	"senateMember": {
	    level: "federal",
	    description: "US Senator"
	},
	// STATE
	"governor": {
	    level: "state",
	    description: "State Governor"
	},
	"stateSenateMember": {
	    level: "state",
	    description: "State Senator"
	},
	"assemblyMember": {
	    level: "state",
	    description: "State Assembly Member"
	},
	// COUNTY
	"countySupervisor": {
	    level: "county",
	    description: "County Supervisor"
	},
	"countyManager": {
	    level: "county",
	    description: "County Manager"
	},
	// CITY
	"mayor": {
	    level: "city",
	    description: "Mayor"
	},
	"cityManager": {
	    level: "city",
	    description: "City Manager"
	},
	"councilMember": {
	    level: "city",
	    description: "Council Member"
	},
	"viceMayor": {
	    level: "city",
	    description: "Vice Mayor"
	},
    }
    return defs[positionName]
}


export {
    hasValidUser,
    hasValidArgs,
    getFilteredIssues,
    parseUrl,
    makeUrl,
    groupBy,
    groupSort,
    groupSortByKey,    
    groupFlat,
    jsonPointerHas,
    getFilteredItems,
    getTagString,
    makeTagArray,
    deepCopy,
    makeCloneUser,
    jsonSetPathValue,
    jsonDeleteKeys,
    includes,
    distinct,
    round,
    firstCross,
    jsonDeleteValues,
    getPositionAttributes,
    jsonPretty,
    jsonString,
    jsonHasPath
}
